import { render, staticRenderFns } from "./Izmeni.vue?vue&type=template&id=0d8f0816&scoped=true&"
import script from "./Izmeni.vue?vue&type=script&lang=js&"
export * from "./Izmeni.vue?vue&type=script&lang=js&"
import style0 from "./Izmeni.vue?vue&type=style&index=0&id=0d8f0816&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8f0816",
  null
  
)

export default component.exports